'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DashboardIcon = function DashboardIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M11.724 12.017A5.474 5.474 0 0 0 13 8.5a5.403 5.403 0 0 0-.145-1.234l.812-.812.779-.779a7.477 7.477 0 0 1-2.01 8.462l-2.108-2.102.708-.707zM0 8.5a7.475 7.475 0 0 0 2.563 5.636l2.109-2.1-.708-.708-.688.689A5.474 5.474 0 0 1 2.026 9H3V8h-.975a5.474 5.474 0 0 1 1.251-3.017l.688.688.708-.707-.689-.688A5.474 5.474 0 0 1 7 3.026V4h1v-.975a5.467 5.467 0 0 1 3.319 1.535l.714-.714.707-.707A7.497 7.497 0 0 0 0 8.499zm14.444-5.651l.707.707-6.301 6.3a1.514 1.514 0 1 1-.707-.706zM8 10.499a.5.5 0 1 0-.5.5.501.501 0 0 0 .5-.5z'
    }) : _react2.default.createElement('path', {
      d: 'M1.028 8a6.45 6.45 0 0 0 1.547 3.718l1.39-1.39.707.708-2.109 2.1A7.495 7.495 0 1 1 12.74 2.14l-.71.71A6.478 6.478 0 0 0 8 1.024V3H7V1.025A6.465 6.465 0 0 0 3.276 2.57l1.396 1.395-.708.708L2.57 3.276A6.466 6.466 0 0 0 1.025 7H3v1zm7.822.857a1.514 1.514 0 1 1-.707-.707l6.301-6.301.707.707zM8 9.5a.5.5 0 1 0-.5.5.501.501 0 0 0 .5-.5zm5.666-4.044a6.43 6.43 0 0 1-1.241 6.262l-1.39-1.39-.707.708 2.109 2.1a7.477 7.477 0 0 0 2.009-8.46z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M11 6.146a7.338 7.338 0 0 0-4.342 1.8L7.973 9.26l-.707.707-1.315-1.316A7.338 7.338 0 0 0 4.146 13H6v1H4.149a7.324 7.324 0 0 0 1.81 4.346l1.29-1.29.707.708c-2.174 2.174-.987.974-2.767 2.817l.002.002-.694.725A10.492 10.492 0 1 1 18.86 6.018L17.18 7.7l.182-.182-.71.71A7.353 7.353 0 0 0 12 6.145V8h-1zm7.503 15.162a10.473 10.473 0 0 0 2.19-12.88l-.487.487-.259.259-1.597 1.597a7.303 7.303 0 0 1-1.301 7.565L15.75 17.04l-.707.707 2.774 2.828-.01.009zm3.022-16.54l-8.648 8.648a2.505 2.505 0 1 0 .707.707l8.648-8.648z'
    }) : _react2.default.createElement('path', {
      d: 'M5.191 18.583l-.694.725A10.492 10.492 0 1 1 18.86 4.018l-.71.71A9.489 9.489 0 1 0 5.19 18.583zM7.266 7.968l.707-.707-1.315-1.315A7.338 7.338 0 0 1 11 4.146V6h1V4.146a7.353 7.353 0 0 1 4.652 2.081l.71-.71a8.373 8.373 0 1 0-11.399 12.26c.67-.698.257-.277 1.993-2.013l-.707-.707-1.29 1.289A7.333 7.333 0 0 1 4.145 12H6v-1H4.144a7.345 7.345 0 0 1 1.807-4.347zm6.318 4.155a2.505 2.505 0 1 1-.707-.707l8.648-8.648.707.707zM13 13.5a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5zm6.947-6.326a9.442 9.442 0 0 1-2.138 11.41l.694.724a10.473 10.473 0 0 0 2.19-12.88zm-.837.837l-.76.76a7.303 7.303 0 0 1-1.301 7.565l-1.297-1.297-.708.707 1.993 2.031a8.339 8.339 0 0 0 2.073-9.766z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M27.601 9.52a14.462 14.462 0 0 1-2.218 18.57l-4.226-4.226.707-.707 1.392 1.392A10.439 10.439 0 0 0 24.69 12.43zM9.843 23.864l-.707-.707-1.392 1.392a10.432 10.432 0 0 1-2.717-6.55H7v-1H5.025a10.443 10.443 0 0 1 2.717-6.55l1.394 1.394.707-.707L8.45 9.742A10.443 10.443 0 0 1 15 7.025V9h1V7.025a10.46 10.46 0 0 1 6.858 2.996l2.832-2.832a14.491 14.491 0 1 0-20.073 20.9zM15.5 17a2.505 2.505 0 1 0 2.084 1.123L28.296 7.41l-.707-.706-10.712 10.71A2.486 2.486 0 0 0 15.5 17z'
  }) : _react2.default.createElement('path', {
    d: 'M2 17.5a13.45 13.45 0 0 0 4.329 9.878l-.712.712A14.49 14.49 0 1 1 25.69 7.189l-.712.712A13.49 13.49 0 0 0 2 17.5zm23.416-5.795l-.726.726a10.439 10.439 0 0 1-1.434 12.118l-1.392-1.392-.707.707 1.394 1.394.338.338.369.369a11.426 11.426 0 0 0 2.158-14.26zm2.185-2.185l-.731.731a13.42 13.42 0 0 1-2.199 17.127l.712.712A14.462 14.462 0 0 0 27.6 9.52zM9.136 11.843l.707-.707L8.45 9.742A10.443 10.443 0 0 1 15 7.025V9h1V7.025a10.46 10.46 0 0 1 6.858 2.996l.707-.707a11.487 11.487 0 1 0-15.823 16.65l.369-.368.338-.338 1.394-1.394-.707-.707-1.392 1.392A10.431 10.431 0 0 1 5.027 18H7v-1H5.025a10.443 10.443 0 0 1 2.717-6.55zm8.448 6.28a2.505 2.505 0 1 1-.707-.707L27.59 6.705l.707.707zM17 19.5a1.5 1.5 0 1 0-1.5 1.5 1.501 1.501 0 0 0 1.5-1.5z'
  }));
};

exports.default = DashboardIcon;